import PineappleStudies from './pineapple_studies/PineappleStudies';
import ClientPaymentStatus from './client_payment_status/ClientPaymentStatus';
import CaregiverPaymentStatus from './caregiver_payment_status/CaregiverPaymentStatus';

const largeWidgetWidth = 16;
const smallWidgetWidth = 8;
const widgetHeight = 1;

const WIDGET_MAPPER = {
  'PINEAPPLE_STUDIES': {
    component: PineappleStudies,
    title: 'dashboardWidgets.Pineapple.Title',
    description: 'dashboardWidgets.Pineapple.Description',
    type: 'TEASER',
    height: {
      lg: widgetHeight,
      md: widgetHeight,
      sm: widgetHeight,
    },
    width: {
      lg: largeWidgetWidth,
      md: largeWidgetWidth,
      sm: smallWidgetWidth,
    },
  },
  'CLIENT_PAYMENT_STATUS': {
    component: ClientPaymentStatus,
    title: 'dashboardWidgets.ClientPaymentStatus.Title',
    description: 'dashboardWidgets.ClientPaymentStatus.Description',
    type: 'PAYMENT',
    height: {
      lg: widgetHeight,
      md: widgetHeight,
      sm: widgetHeight,
    },
    width: {
      lg: smallWidgetWidth,
      md: smallWidgetWidth,
      sm: smallWidgetWidth,
    },
  },
  'CAREGIVER_PAYMENT_STATUS': {
    component: CaregiverPaymentStatus,
    title: 'dashboardWidgets.CaregiverPaymentStatus.Title',
    description: 'dashboardWidgets.CaregiverPaymentStatus.Description',
    type: 'PAYMENT',
    height: {
      lg: widgetHeight,
      md: widgetHeight,
      sm: widgetHeight,
    },
    width: {
      lg: smallWidgetWidth,
      md: smallWidgetWidth,
      sm: smallWidgetWidth,
    },
  },
};

export {
  WIDGET_MAPPER,
};
